<template>
  <div v-if="legalDocuments">
    <popup-add-legal-document ref="popupAddLegalDocument" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Legal documents</h3>
        <p class="mt-5">
          Legal documents are dynamic rich text documents that has one or more
          consent types attached. A legal document can be used together with a
          dynamic form and in booking setup.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            v-if="$AuthService.hasPermission('vp.crm.legaldocuments.edit')"
            class="vs-con-loading__container"
            @click="$refs.popupAddLegalDocument.show()"
            type="relief"
            vslor="primary"
            >Add document</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        max-items="50"
        v-model="selected"
        pagination
        search
        :data="legalDocuments"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>Consent types</vs-th>
          <vs-th>Enabled</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.consents.length }} types
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="status-category">
                  <vs-chip
                    :color="tr.enabled | yesnocolor"
                    class="status-circle"
                  ></vs-chip>
                  {{ tr.enabled | yesno }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupAddLegalDocument from "./PopupAddLegalDocument.vue";
import { mapGetters } from "vuex";
export default {
  components: { PopupAddLegalDocument },
  data() {
    return {
      newMessageTitle: "",
      selected: [],
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-legaldocument",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Profile lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      legalDocuments: "legalDocuments/documents",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("legalDocuments/getAll");
    this.$vs.loading.close();
  },
};
</script>
